import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { StringResourceService } from './../../services/string-resource.service';
import { LogService } from "@services/log.service";


export default class SharedTranslationLoader implements TranslateLoader {

  StringResourceGroups: string[] = [
    'GlobalSearch',
    'Header',
    'Dialog',
    'TankNotifications',
    'TankNav',
    'TankDetails',
    'TankTabs',
    'TankPage',
    'TankHistory',
    'TankSetup'
  ];

  constructor(private logger: LogService, private stringResourceService: StringResourceService) { }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getTranslation(lang: string): Observable<any> {
    this.logger.info('SharedTranslationLoader', 'getTranslation', lang);
    return this.stringResourceService
      .GetLocalizedResourceGroups(this.StringResourceGroups)
      .pipe(
        mergeMap((data) => {
          return of(data);
        }),
      );
  }
}
